<div class="image-wrapper">
  <div id="topImage">
  </div>
</div>
<div class="headerTitle">
  <h2>{{title}}</h2>
  <hr class="headerLine">
</div>
